import _ from 'lodash';
import React from 'react';

export default (props) => {
  const type = props.type || 'solid';
  const className = _.compact([
    'flaticon',
    type,
    props.name,
    props.className
  ]).join(' ');

  return <span className={className} />;
};
